import React, { ComponentProps } from 'react'

export default function ArrowTopRightIcon(props: ComponentProps<"svg">) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
      <path d="M9.75 8.02148L16.1369 8.02148L16.1369 14.4084" stroke="#6C53E8" strokeWidth="1.35487" strokeLinecap="round" strokeLinejoin="round"/>
      <line x1="15.3086" y1="8.78909" x2="7.96366" y2="16.134" stroke="#6C53E8" strokeWidth="1.35487" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}
